// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\MarineTrafficServiceVessel\ApiMarineTrafficServiceVessel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BowThruster, BowThrusterData, BowThrusterOptions } from 'data/models/BowThruster';
import { Country, CountryData, CountryOptions } from 'data/models/Country';
import { DeclarationOfSecurity, DeclarationOfSecurityData, DeclarationOfSecurityOptions } from 'data/models/DeclarationOfSecurity';
import { MarineTrafficResult, MarineTrafficResultData, MarineTrafficResultOptions } from 'data/models/MarineTrafficResult';
import { MarineTrafficVesselServiceQuery, MarineTrafficVesselServiceQueryData, MarineTrafficVesselServiceQueryOptions } from 'data/models/MarineTrafficVesselServiceQuery';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';

// MarineTrafficServiceVesselData is the class that MarineTrafficServiceVessel serializes to/from
export interface MarineTrafficServiceVesselData {
    Id : number;
	
    Flag : CountryData | null;
    FlagId : number | null;
    VesselResult : MarineTrafficResultData | null;
    VesselResultId : number;
    VesselServiceQuery : MarineTrafficVesselServiceQueryData | null;
    VesselServiceQueryId : number | null;
	
    Alias : string | null;
    Beam : NullableMeasurementData;
    BowThruster : BowThrusterData;
    CallSign : string | null;
    ConstructionCompleted : number | null;
    CreatedOnUtc : /* ISO8601 */ string;
    Depth : NullableMeasurementData;
    DOS : DeclarationOfSecurityData;
    ExpectedPassengerCount : number | null;
    GrossTonnage : NullableMeasurementData;
    Guid : /* GUID */ string;
    HullIdentificationNumber : string | null;
    IMO : string | null;
    IsCruiseVessel : boolean | null;
    IsGovernmentVessel : boolean | null;
    Length : NullableMeasurementData;
    MaxDraft : NullableMeasurementData;
    MMSID : string | null;
    ModifiedOnUtc : /* ISO8601 */ string;
    Name : string | null;
    OfficialNumber : string | null;
    PortOfRegistry : string | null;
    StateNumber : string | null;
    VesselType : string | null;
    VIN : string | null;
}

// MarineTrafficServiceVesselOptions is the class which may be passed to the MarineTrafficServiceVessel constructor to define optional initial data values
export interface MarineTrafficServiceVesselOptions {
    Id : number;
	
    Flag? : CountryOptions | null;
    FlagId? : number | null;
    VesselResult? : MarineTrafficResultOptions | null;
    VesselResultId? : number;
    VesselServiceQuery? : MarineTrafficVesselServiceQueryOptions | null;
    VesselServiceQueryId? : number | null;
	
    Alias? : string | null;
    Beam? : NullableMeasurementOptions;
    BowThruster? : BowThrusterOptions;
    CallSign? : string | null;
    ConstructionCompleted? : number | null;
    CreatedOnUtc? : /* ISO8601 */ string;
    Depth? : NullableMeasurementOptions;
    DOS? : DeclarationOfSecurityOptions;
    ExpectedPassengerCount? : number | null;
    GrossTonnage? : NullableMeasurementOptions;
    Guid? : /* GUID */ string;
    HullIdentificationNumber? : string | null;
    IMO? : string | null;
    IsCruiseVessel? : boolean | null;
    IsGovernmentVessel? : boolean | null;
    Length? : NullableMeasurementOptions;
    MaxDraft? : NullableMeasurementOptions;
    MMSID? : string | null;
    ModifiedOnUtc? : /* ISO8601 */ string;
    Name? : string | null;
    OfficialNumber? : string | null;
    PortOfRegistry? : string | null;
    StateNumber? : string | null;
    VesselType? : string | null;
    VIN? : string | null;
}

export class MarineTrafficServiceVessel {
    public Id : DataSignal<number>;
	
    public Flag : DataSignal<Country | null>;
    public FlagId : DataSignal<number | null>;
    public VesselResult : DataSignal<MarineTrafficResult | null>;
    public VesselResultId : DataSignal<number>;
    public VesselServiceQuery : DataSignal<MarineTrafficVesselServiceQuery | null>;
    public VesselServiceQueryId : DataSignal<number | null>;
	
    public Alias : DataSignal<string | null>;
    public Beam : NullableMeasurement;
    public BowThruster : BowThruster;
    public CallSign : DataSignal<string | null>;
    public ConstructionCompleted : DataSignal<number | null>;
    public CreatedOnUtc : DataSignal<TZDate>;
    public Depth : NullableMeasurement;
    public DOS : DeclarationOfSecurity;
    public ExpectedPassengerCount : DataSignal<number | null>;
    public GrossTonnage : NullableMeasurement;
    public Guid : DataSignal<string>;
    public HullIdentificationNumber : DataSignal<string | null>;
    public IMO : DataSignal<string | null>;
    public IsCruiseVessel : DataSignal<boolean | null>;
    public IsGovernmentVessel : DataSignal<boolean | null>;
    public Length : NullableMeasurement;
    public MaxDraft : NullableMeasurement;
    public MMSID : DataSignal<string | null>;
    public ModifiedOnUtc : DataSignal<TZDate>;
    public Name : DataSignal<string | null>;
    public OfficialNumber : DataSignal<string | null>;
    public PortOfRegistry : DataSignal<string | null>;
    public StateNumber : DataSignal<string | null>;
    public VesselType : DataSignal<string | null>;
    public VIN : DataSignal<string | null>;

    constructor();
    constructor(data : MarineTrafficServiceVesselOptions);
    constructor(data: MarineTrafficServiceVesselOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Flag = S.value<Country | null>(null);
        this.FlagId = jsonableObservable(S.value<number | null>(data && data.FlagId !== undefined ? data.FlagId : null));
        this.VesselResult = S.value<MarineTrafficResult | null>(null);
        this.VesselResultId = jsonableObservable(S.value<number>(data && data.VesselResultId !== undefined ? data.VesselResultId : 0));
        this.VesselServiceQuery = S.value<MarineTrafficVesselServiceQuery | null>(null);
        this.VesselServiceQueryId = jsonableObservable(S.value<number | null>(data && data.VesselServiceQueryId !== undefined ? data.VesselServiceQueryId : null));
	    
        this.Alias = jsonableObservable(S.value<string | null>(data && data.Alias !== undefined ? data.Alias : null));
        this.Beam = data && data.Beam !== undefined ? new NullableMeasurement(data.Beam) : new NullableMeasurement();
        this.BowThruster = data && data.BowThruster !== undefined ? new BowThruster(data.BowThruster) : new BowThruster();
        this.CallSign = jsonableObservable(S.value<string | null>(data && data.CallSign !== undefined ? data.CallSign : null));
        this.ConstructionCompleted = jsonableObservable(S.value<number | null>(data && data.ConstructionCompleted !== undefined ? data.ConstructionCompleted : null));
        this.CreatedOnUtc = jsonableObservable(S.value<TZDate>(data && data.CreatedOnUtc !== undefined ? new TZDate(data.CreatedOnUtc) : new TZDate(0), TZDate.eq));
        this.Depth = data && data.Depth !== undefined ? new NullableMeasurement(data.Depth) : new NullableMeasurement();
        this.DOS = data && data.DOS !== undefined ? new DeclarationOfSecurity(data.DOS) : new DeclarationOfSecurity();
        this.ExpectedPassengerCount = jsonableObservable(S.value<number | null>(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new NullableMeasurement(data.GrossTonnage) : new NullableMeasurement();
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.HullIdentificationNumber = jsonableObservable(S.value<string | null>(data && data.HullIdentificationNumber !== undefined ? data.HullIdentificationNumber : null));
        this.IMO = jsonableObservable(S.value<string | null>(data && data.IMO !== undefined ? data.IMO : null));
        this.IsCruiseVessel = jsonableObservable(S.value<boolean | null>(data && data.IsCruiseVessel !== undefined ? data.IsCruiseVessel : null));
        this.IsGovernmentVessel = jsonableObservable(S.value<boolean | null>(data && data.IsGovernmentVessel !== undefined ? data.IsGovernmentVessel : null));
        this.Length = data && data.Length !== undefined ? new NullableMeasurement(data.Length) : new NullableMeasurement();
        this.MaxDraft = data && data.MaxDraft !== undefined ? new NullableMeasurement(data.MaxDraft) : new NullableMeasurement();
        this.MMSID = jsonableObservable(S.value<string | null>(data && data.MMSID !== undefined ? data.MMSID : null));
        this.ModifiedOnUtc = jsonableObservable(S.value<TZDate>(data && data.ModifiedOnUtc !== undefined ? new TZDate(data.ModifiedOnUtc) : new TZDate(0), TZDate.eq));
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
        this.OfficialNumber = jsonableObservable(S.value<string | null>(data && data.OfficialNumber !== undefined ? data.OfficialNumber : null));
        this.PortOfRegistry = jsonableObservable(S.value<string | null>(data && data.PortOfRegistry !== undefined ? data.PortOfRegistry : null));
        this.StateNumber = jsonableObservable(S.value<string | null>(data && data.StateNumber !== undefined ? data.StateNumber : null));
        this.VesselType = jsonableObservable(S.value<string | null>(data && data.VesselType !== undefined ? data.VesselType : null));
        this.VIN = jsonableObservable(S.value<string | null>(data && data.VIN !== undefined ? data.VIN : null));
    }

    static key(obj : MarineTrafficServiceVessel) {
        return obj.Id();
    }
    
    static dataKey(obj : MarineTrafficServiceVesselOptions) {
        return obj.Id;
    }

    static update(obj : MarineTrafficServiceVessel, data : MarineTrafficServiceVesselOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.FlagId !== undefined) obj.FlagId(data.FlagId);
            if (data.VesselResultId !== undefined) obj.VesselResultId(data.VesselResultId);
            if (data.VesselServiceQueryId !== undefined) obj.VesselServiceQueryId(data.VesselServiceQueryId);
	        
            if (data.Alias !== undefined) obj.Alias(data.Alias);
            if (data.Beam !== undefined) NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.BowThruster !== undefined) BowThruster.update(obj.BowThruster, data.BowThruster);
            if (data.CallSign !== undefined) obj.CallSign(data.CallSign);
            if (data.ConstructionCompleted !== undefined) obj.ConstructionCompleted(data.ConstructionCompleted);
            if (data.CreatedOnUtc !== undefined) obj.CreatedOnUtc(new TZDate(data.CreatedOnUtc));
            if (data.Depth !== undefined) NullableMeasurement.update(obj.Depth, data.Depth);
            if (data.DOS !== undefined) DeclarationOfSecurity.update(obj.DOS, data.DOS);
            if (data.ExpectedPassengerCount !== undefined) obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.GrossTonnage !== undefined) NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.HullIdentificationNumber !== undefined) obj.HullIdentificationNumber(data.HullIdentificationNumber);
            if (data.IMO !== undefined) obj.IMO(data.IMO);
            if (data.IsCruiseVessel !== undefined) obj.IsCruiseVessel(data.IsCruiseVessel);
            if (data.IsGovernmentVessel !== undefined) obj.IsGovernmentVessel(data.IsGovernmentVessel);
            if (data.Length !== undefined) NullableMeasurement.update(obj.Length, data.Length);
            if (data.MaxDraft !== undefined) NullableMeasurement.update(obj.MaxDraft, data.MaxDraft);
            if (data.MMSID !== undefined) obj.MMSID(data.MMSID);
            if (data.ModifiedOnUtc !== undefined) obj.ModifiedOnUtc(new TZDate(data.ModifiedOnUtc));
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.OfficialNumber !== undefined) obj.OfficialNumber(data.OfficialNumber);
            if (data.PortOfRegistry !== undefined) obj.PortOfRegistry(data.PortOfRegistry);
            if (data.StateNumber !== undefined) obj.StateNumber(data.StateNumber);
            if (data.VesselType !== undefined) obj.VesselType(data.VesselType);
            if (data.VIN !== undefined) obj.VIN(data.VIN);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/MarineTrafficServiceVessel.ts